import { render, staticRenderFns } from "./noteDialog.vue?vue&type=template&id=763ebf10&scoped=true&lang=html"
import script from "./noteDialog.vue?vue&type=script&lang=js"
export * from "./noteDialog.vue?vue&type=script&lang=js"
import style0 from "./noteDialog.vue?vue&type=style&index=0&id=763ebf10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763ebf10",
  null
  
)

export default component.exports